import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { useSelector } from 'react-redux';
import emailjs from 'emailjs-com';
import Header from '../components/Header/Header';
import './ContactPage.css';

const ContactPage = () => {
  const { currentLanguage } = useSelector((state) => state.language);
  const formRef = useRef();
  
  // استخدام أسماء متوافقة مع EmailJS
  const [formData, setFormData] = useState({
    from_name: '',      // تم التغيير من name
    from_email: '',     // تم التغيير من email
    phone: '',
    subject: '',
    message: '',
    insurance_type: ''  // تم التغيير من insuranceType
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');

  
   const EMAILJS_CONFIG = {
    // SERVICE_ID: 'service_48vgbnv', 
    SERVICE_ID: 'service_eb4wdg5', 

    TEMPLATE_ID: 'template_a7r5ni4',  
    USER_ID: 'c2MVQ4SGfFy62t155',  
    // TO_EMAIL: 'salsabilohida@gmail.com'  
    TO_EMAIL: 'info@sanad-ins.com'  

  };
  const contactInfo = {
    phone: '+218927822144',
    email: 'info@sanad-ins.com',
    address: {
      en: 'Tripoli Tower, Tripoli, Libya',
      ar: 'طرابلس، ليبيا'
    },
    workingHours: {
      en: 'Sunday - Thursday: 8:00 AM - 4:00 PM',
      ar: 'الأحد - الخميس: 8:00 صباحًا - 4:00 مساءً'
    },
    emergency: '+218927822144'
  };

  const departments = [
    {
      title: { en: 'Customer Service', ar: 'خدمة العملاء' },
      email: 'support@sanad-ins.com',
      phone: '+218927822144',
      description: {
        en: 'For policy inquiries, claims assistance, and general questions',
        ar: 'لاستفسارات الوثائق، مساعدة المطالبات، والأسئلة العامة'
      }
    },
    {
      title: { en: 'Sales Department', ar: 'قسم المبيعات' },
      email: 'sales@sanad-ins.com',
      phone: '+218927822144',
      description: {
        en: 'For new policy inquiries and insurance quotes',
        ar: 'لاستفسارات الوثائق الجديدة وعروض أسعار التأمين'
      }
    },
    {
      title: { en: 'Claims Department', ar: 'قسم المطالبات' },
      email: 'claims@sanad-ins.com',
      phone: '+218927822144',
      description: {
        en: 'For reporting claims and claims follow-up',
        ar: 'لإبلاغ المطالبات ومتابعتها'
      }
    }
  ];

  const insuranceTypes = [
    { value: '', label: { en: 'Select Insurance Type', ar: 'اختر نوع التأمين' } },
    { value: 'car', label: { en: 'Car Insurance', ar: 'تأمين المركبات' } },
    { value: 'travel', label: { en: 'Travel Insurance', ar: 'تأمين السفر' } },
    { value: 'property', label: { en: 'Property Insurance', ar: 'تأمين الممتلكات' } },
    { value: 'health', label: { en: 'Health Insurance', ar: 'التأمين الصحي' } },
    { value: 'business', label: { en: 'Business Insurance', ar: 'تأمين الأعمال' } },
    { value: 'other', label: { en: 'Other', ar: 'أخرى' } }
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    
    // مسح رسائل الخطأ عند تعديل النموذج
    if (submitStatus || errorMessage) {
      setSubmitStatus(null);
      setErrorMessage('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorMessage('');
    setSubmitStatus(null);

    try {
      // إرسال البريد باستخدام EmailJS
      const result = await emailjs.sendForm(
        EMAILJS_CONFIG.SERVICE_ID,
        EMAILJS_CONFIG.TEMPLATE_ID,
        formRef.current,
        EMAILJS_CONFIG.USER_ID
      );
     

      console.log('Email sent successfully:', result.text);
      
      // رسالة نجاح
      setSubmitStatus('success');
      
      // إعادة تعيين النموذج
      setFormData({
        from_name: '',
        from_email: '',
        phone: '',
        subject: '',
        message: '',
        insurance_type: ''
      });

    } catch (error) {
      console.error('Failed to send email:', error);
      setErrorMessage(
        currentLanguage === 'en' 
          ? 'Failed to send message. Please try again or contact us directly.' 
          : 'فشل إرسال الرسالة. يرجى المحاولة مرة أخرى أو التواصل معنا مباشرة.'
      );
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
      
      // إعادة تعيين حالة النجاح بعد 5 ثوان
      if (submitStatus === 'success') {
        setTimeout(() => {
          setSubmitStatus(null);
        }, 5000);
      }
    }
  };

  return (
    <div className="contact-page">
      <Header />
      
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="hero-content"
          >
            <h1>
              {currentLanguage === 'en' 
                ? 'Contact Us' 
                : 'تواصل معنا'}
            </h1>
            <p>
              {currentLanguage === 'en' 
                ? 'We\'re here to help. Get in touch with our team for any questions or assistance.' 
                : 'نحن هنا للمساعدة. تواصل مع فريقنا لأي استفسارات أو مساعدة.'}
            </p>
          </motion.div>
        </div>
      </section>

      <div className="contact-container">
        <div className="container">
          <div className="contact-grid">
            {/* معلومات الاتصال */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              className="contact-info"
            >
              <h2>{currentLanguage === 'en' ? 'Get in Touch' : 'ابق على تواصل'}</h2>
              
              <div className="info-section">
                <div className="info-item">
                  <div className="info-icon">📞</div>
                  <div className="info-content">
                    <h3>{currentLanguage === 'en' ? 'Phone' : 'هاتف'}</h3>
                    <p>{contactInfo.phone}</p>
                    <p className="emergency">
                      <strong>{currentLanguage === 'en' ? 'Emergency:' : 'طوارئ:'}</strong> {contactInfo.emergency}
                    </p>
                  </div>
                </div>
                
                <div className="info-item">
                  <div className="info-icon">📧</div>
                  <div className="info-content">
                    <h3>{currentLanguage === 'en' ? 'Email' : 'بريد إلكتروني'}</h3>
                    <p>{contactInfo.email}</p>
                  </div>
                </div>
                
                <div className="info-item">
                  <div className="info-icon">📍</div>
                  <div className="info-content">
                    <h3>{currentLanguage === 'en' ? 'Address' : 'عنوان'}</h3>
                    <p>{contactInfo.address[currentLanguage]}</p>
                  </div>
                </div>
                
                <div className="info-item">
                  <div className="info-icon">🕐</div>
                  <div className="info-content">
                    <h3>{currentLanguage === 'en' ? 'Working Hours' : 'ساعات العمل'}</h3>
                    <p>{contactInfo.workingHours[currentLanguage]}</p>
                  </div>
                </div>
              </div>

              {/* قسم إشعار EmailJS */}
              <div className="emailjs-notice">
                <div className="notice-icon">⚡</div>
                <div className="notice-content">
                  <h4>{currentLanguage === 'en' ? 'Instant Email Delivery' : 'توصيل فوري للبريد'}</h4>
                  <p>
                    {currentLanguage === 'en' 
                      ? 'Your message will be sent directly to our team at info@sanad-ins.com'
                      : 'سيتم إرسال رسالتك مباشرة إلى فريقنا على info@sanad-ins.com'}
                  </p>
                </div>
              </div>

              {/* الأقسام */}
              <div className="departments-section">
                <h3>{currentLanguage === 'en' ? 'Our Departments' : 'أقسامنا'}</h3>
                <div className="departments-grid">
                  {departments.map((dept, index) => (
                    <motion.div
                      key={index}
                      className="department-card"
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5, delay: index * 0.1 }}
                      whileHover={{ y: -5 }}
                    >
                      <h4>{dept.title[currentLanguage]}</h4>
                      <p className="dept-description">{dept.description[currentLanguage]}</p>
                      <div className="dept-contact">
                        <p>📧 {dept.email}</p>
                        <p>📞 {dept.phone}</p>
                      </div>
                    </motion.div>
                  ))}
                </div>
              </div>
            </motion.div>

            {/* نموذج الاتصال */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="contact-form-section"
            >
              <h2>{currentLanguage === 'en' ? 'Send us a Message' : 'أرسل لنا رسالة'}</h2>
              
              {submitStatus === 'success' && (
                <motion.div
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  className="success-message"
                >
                  <span>✅</span>
                  <div>
                    <p className="success-title">
                      {currentLanguage === 'en' 
                        ? 'Message Sent Successfully!' 
                        : 'تم إرسال الرسالة بنجاح!'}
                    </p>
                    <p className="success-detail">
                      {currentLanguage === 'en' 
                        ? 'Your message has been sent to info@sanad-ins.com. We will contact you shortly.' 
                        : 'تم إرسال رسالتك إلى info@sanad-ins.com. سنتواصل معك قريبًا.'}
                    </p>
                  </div>
                </motion.div>
              )}
              
              {submitStatus === 'error' && (
                <motion.div
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  className="error-message"
                >
                  <span>❌</span>
                  <div>
                    <p className="error-title">
                      {currentLanguage === 'en' 
                        ? 'Failed to Send Message' 
                        : 'فشل إرسال الرسالة'}
                    </p>
                    <p className="error-detail">{errorMessage}</p>
                  </div>
                </motion.div>
              )}
              
              <form ref={formRef} onSubmit={handleSubmit} className="contact-form">
                {/* الحقول المخفية لـ EmailJS */}
                <input type="hidden" name="to_email" value={EMAILJS_CONFIG.TO_EMAIL} />
                <input type="hidden" name="company_name" value="سند للتأمين" />
                
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="from_name">
                      {currentLanguage === 'en' ? 'Full Name' : 'الاسم الكامل'} *
                    </label>
                    <input
                      type="text"
                      id="from_name"
                      name="from_name"  // اسم متوافق مع state وEmailJS
                      value={formData.from_name}
                      onChange={handleChange}
                      required
                      placeholder={currentLanguage === 'en' ? 'Enter your name' : 'أدخل اسمك'}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="from_email">
                      {currentLanguage === 'en' ? 'Email Address' : 'البريد الإلكتروني'} *
                    </label>
                    <input
                      type="email"
                      id="from_email"
                      name="from_email"  // اسم متوافق مع state وEmailJS
                      value={formData.from_email}
                      onChange={handleChange}
                      required
                      placeholder={currentLanguage === 'en' ? 'Enter your email' : 'أدخل بريدك الإلكتروني'}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="phone">
                      {currentLanguage === 'en' ? 'Phone Number' : 'رقم الهاتف'}
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder={currentLanguage === 'en' ? 'Enter your phone number' : 'أدخل رقم هاتفك'}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="insurance_type">
                      {currentLanguage === 'en' ? 'Insurance Type' : 'نوع التأمين'}
                    </label>
                    <select
                      id="insurance_type"
                      name="insurance_type"
                      value={formData.insurance_type}
                      onChange={handleChange}
                    >
                      {insuranceTypes.map((type, index) => (
                        <option key={index} value={type.value}>
                          {type.label[currentLanguage]}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="subject">
                    {currentLanguage === 'en' ? 'Subject' : 'الموضوع'} *
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    placeholder={currentLanguage === 'en' ? 'Enter subject' : 'أدخل الموضوع'}
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">
                    {currentLanguage === 'en' ? 'Message' : 'الرسالة'} *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder={currentLanguage === 'en' ? 'Enter your message here...' : 'أدخل رسالتك هنا...'}
                  ></textarea>
                </div>
                
                <div className="form-actions">
                  <motion.button
                    type="submit"
                    className="submit-btn"
                    disabled={isSubmitting}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="spinner"></span>
                        {currentLanguage === 'en' ? 'Sending...' : 'جاري الإرسال...'}
                      </>
                    ) : (
                      <>
                        <span className="send-icon">📨</span>
                        {currentLanguage === 'en' ? 'Send Message' : 'إرسال الرسالة'}
                      </>
                    )}
                  </motion.button>
                  
                  <div className="privacy-notice">
                    <span className="lock-icon">🔒</span>
                    <p>
                      {currentLanguage === 'en' 
                        ? 'Your information is secure and will only be used to respond to your inquiry.'
                        : 'معلوماتك آمنة وسيتم استخدامها فقط للرد على استفسارك.'}
                    </p>
                  </div>
                </div>
              </form>
            </motion.div>
          </div>
        </div>
      </div>

      {/* قسم معلومات إضافية */}
      <section className="email-info-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="email-info-content"
          >
            <h2>{currentLanguage === 'en' ? 'Direct Email Contact' : 'اتصال بريدي مباشر'}</h2>
            <div className="email-methods">
              <div className="method-card">
                <div className="method-icon">📧</div>
                <h3>{currentLanguage === 'en' ? 'Send Direct Email' : 'إرسال بريد مباشر'}</h3>
                <p>
                  {currentLanguage === 'en' 
                    ? 'You can also email us directly at:' 
                    : 'يمكنك أيضًا مراسلتنا مباشرة على:'}
                </p>
                <a href={`mailto:${contactInfo.email}?subject=Inquiry from Sanad Insurance Website`} className="direct-email-link">
                  {contactInfo.email}
                </a>
              </div>
              
              <div className="method-card">
                <div className="method-icon">⚡</div>
                <h3>{currentLanguage === 'en' ? 'Quick Response' : 'استجابة سريعة'}</h3>
                <p>
                  {currentLanguage === 'en' 
                    ? 'We aim to respond to all emails within 24 hours during business days.'
                    : 'نهدف إلى الرد على جميع الرسائل خلال 24 ساعة في أيام العمل.'}
                </p>
              </div>
              
              <div className="method-card">
                <div className="method-icon">🛡️</div>
                <h3>{currentLanguage === 'en' ? 'Secure Communication' : 'اتصال آمن'}</h3>
                <p>
                  {currentLanguage === 'en' 
                    ? 'All communications are encrypted and handled with strict confidentiality.'
                    : 'جميع الاتصالات مشفرة ومعالجة بسرية تامة.'}
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* قسم الـ FAQ للاتصال */}
      <section className="contact-faq">
        <div className="container">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2>{currentLanguage === 'en' ? 'Contact FAQ' : 'الأسئلة الشائعة للاتصال'}</h2>
            
            <div className="faq-grid">
              <div className="faq-item">
                <h3>{currentLanguage === 'en' ? 'How quickly will you respond?' : 'ما سرعة الرد؟'}</h3>
                <p>
                  {currentLanguage === 'en' 
                    ? 'We aim to respond to all inquiries within 24 hours during business days. Urgent matters are prioritized.' 
                    : 'نهدف إلى الرد على جميع الاستفسارات خلال 24 ساعة في أيام العمل. يتم إعطاء الأولوية للأمور العاجلة.'}
                </p>
              </div>
              
              <div className="faq-item">
                <h3>{currentLanguage === 'en' ? 'Do I get a confirmation?' : 'هل أحصل على تأكيد؟'}</h3>
                <p>
                  {currentLanguage === 'en' 
                    ? 'Yes, you will receive an automatic confirmation email after submitting the form.' 
                    : 'نعم، ستتلقى بريد تأكيد تلقائي بعد إرسال النموذج.'}
                </p>
              </div>
              
              <div className="faq-item">
                <h3>{currentLanguage === 'en' ? 'Is my information secure?' : 'هل معلوماتي آمنة؟'}</h3>
                <p>
                  {currentLanguage === 'en' 
                    ? 'Yes, we use industry-standard encryption and never share your information with third parties.' 
                    : 'نعم، نستخدم تشفيرًا معياريًا ولا نشارك معلوماتك مع أطراف ثالثة.'}
                </p>
              </div>
              
              <div className="faq-item">
                <h3>{currentLanguage === 'en' ? 'Can I attach documents?' : 'هل يمكنني إرفاق مستندات؟'}</h3>
                <p>
                  {currentLanguage === 'en' 
                    ? 'For security reasons, please don\'t send sensitive documents via this form. We\'ll request them if needed.' 
                    : 'لأسباب أمنية، يرجى عدم إرسال مستندات حساسة عبر هذا النموذج. سنطلبها إذا لزم الأمر.'}
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;